module.exports = __webpack_public_path__ + "img/Ordi.44200561.png";